<template>
  <div id="app">
    <router-view/>
    <footer-bar></footer-bar>
  </div>
</template>

<script>
//  import { Toast } from 'mint-ui';
import FooterBar from 'basic/layout/footerBar'
export default {
  name: 'app',
  data () {
      return {
      }
    },
    components:{
       FooterBar
    },
    beforeRouteUpdate(){
    	console.log(1111)
    }
}
</script>

<style lang="scss">
.page-outbox{
	position: absolute;
	top:0;
	left:0;
	right:0;
	bottom: .46rem;
	overflow: auto;
	font-size: .16rem;
}
#app {
  font-family: '微软雅黑','Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2E3031;
}
.empty-list{
  padding: .5rem 0;
  text-align: center;
  font-size: .15rem;
  color:#999;
}
.query-list{
	min-height: 100.3%;
	.pullDown{
	  position: absolute;
	  top: -32px;
	  left: 0;
	  padding: 10px 0;
	  width: 100%;
	  text-align: center;
	  font-size: 12px;
	  color: #999;
	}
	.pullUp{
	  position: absolute;
	  bottom: -32px;
	  left: 0;
	  padding: 10px 0;
	  width: 100%;
	  text-align: center;
	  font-size: 12px;
	  color: #999;
	}
}
.mint-indicator-wrapper{
  z-index: 120;
}
.mint-indicator-spin{
  display: block;
}
</style>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
  .addr-form{
    .mint-cell{
      padding: 0 .1rem;
      min-height: .4rem;
      border-bottom: 1px solid #ddd;
      &.required .mint-cell-title:before{
        content:"*";
        color:red;
      }
      .mint-cell-wrapper{
        font-size: .14rem;
        color: #333;
        .mint-cell-title{
          padding-right: .1rem;
          width: auto;
          min-width: .6rem;
          color: #666;
          text-align: right;
        }
        .mint-field-core{
          max-width: none;
          text-align: left;
        }
      }
      &.is-textarea{
        .mint-cell-wrapper{
          align-items: flex-start;
          .mint-field-core{
            font-family:inherit;
          }
        }
      }
    }
    .opr-group{
      .mint-button{
        min-width: .65rem;
        height:.35rem;
        font-size: .16rem;
        border-radius: .02rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue